import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnRadialSliderFieldTemplateOptions } from './radial-slider-form-field-template-options.interface';

export interface ISnRadialSliderFormFieldConfig extends FormlyFieldConfig {
  type: 'radial';
  templateOptions?: ISnRadialSliderFieldTemplateOptions;
}
